export const UnderReview = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="30" cy="30" r="29.0625" stroke="white" stroke-width="1.875"/>
        <path d="M30 16.1328V31.1719L39.0234 40.1953" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
);
